// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "\n.username-label[data-v-4b941871] {\n    color: var(--v-primary-base);\n    border-color: var(--v-form-border-base);\n}\n", ""]);
// Exports
module.exports = exports;
